export * from './post-projekte-hochzaehlen.component';
export * from './post-projekte-hochzaehlen.component.module';